export default function Home() {
  return (
    <div className='w-screen h-screen flex items-center justify-center'>
      <h1>Hi!</h1>
    </div>
  )
}
